import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Sender} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'uploadProps': {
            directory: true,
            limit: 20,
        },
        'ev-messageSend': this.onMessageSend,
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value'),
        'ev-$model:attachments': function($v) {
            $this.set('attachments', $v);
        },
        'attachments': $this.get('attachments')
    });
};